import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import type { L, Lang } from '../types/content';
type LanguageContextValue = {
  lang: Lang;
  setLang: (lang: Lang) => void;
  t: (value: L) => string;
};
const STORAGE_KEY = 'win21der-lang';
const LanguageContext = createContext<LanguageContextValue | null>(null);
export function LanguageProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [lang, setLang] = useState<Lang>(() => {
    try {
      return window.localStorage.getItem(STORAGE_KEY) === 'es' ? 'es' : 'en';
    } catch {
      return 'en';
    }
  });
  useEffect(() => {
    document.documentElement.lang = lang;
    try {
      window.localStorage.setItem(STORAGE_KEY, lang);
    } catch {
      /* storage unavailable — keep in-memory preference */
    }
  }, [lang]);
  const t = useCallback((value: L) => value[lang], [lang]);
  const value = useMemo(() => ({
    lang,
    setLang,
    t
  }), [lang, t]);
  return <LanguageContext.Provider value={value} data-id="element-386" data-mp="2jn1g0ujcpbjl">{children}</LanguageContext.Provider>;
}
export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used inside LanguageProvider');
  return ctx;
}